import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import { HttpConnector } from '@/modules/shared/domain/connectors/http';
import TYPES from '@/types';
import { VerifyNipRepository } from '../../domain/repository';
import { VerifyNipDto } from '../../domain/dtos';

@Injectable()
export default class VerifyNipHttpRepository implements VerifyNipRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly path = `${process.env.VUE_APP_API_URL}/api/v1/app/on-boarding/verify-account/`;

  create(verify_nip_dto: VerifyNipDto): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.path, 'POST', verify_nip_dto)
        .then((response) => {
          response.json().then(({ success, data, message }) => {
            if (success) {
              resolve(data);
            } else {
              reject(new Error(message));
            }
          });
        })
        .catch(reject);
    });
  }
}
